import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import { useIntl } from 'react-intl';
import { getLocalizedCountryMap } from 'ui_system/inputs/localizedCountryUtils';
import './index.scss';
import Dropdown from '..';

interface CountryDropdownProps {
  value?: string | null;
  onChange: (value: string) => void;
  icon?: React.ReactNode;
  name?: string;
  errors?: string[];
  guide_us_only?: boolean;
  theme?: string;
  ariaLabelledBy?: string;
  ariaLabel?: string;
}

const CountryDropdown = ({
  value = null,
  onChange,
  icon = <i className="af-triangle-down-2 icon icon-anyfont" />,
  name,
  errors,
  guide_us_only,
  theme,
  ariaLabelledBy,
  ariaLabel,
}: CountryDropdownProps) => {
  const intl = useIntl();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (dropdownRef.current) {
      const $dropdown = $(dropdownRef.current);
      const $semUISearch = $('input.search', $dropdown);
      $semUISearch.attr('autocomplete', 'off');
    }
  }, []);

  const localizedMap = getLocalizedCountryMap(intl.locale);
  const dropdownProps: Record<string, unknown> = {
    name,
    errors,
    guide_us_only,
    options: localizedMap,
    value: guide_us_only ? 'US' : value,
    placeholder: intl.formatMessage({ defaultMessage: 'Select Country' }),
    onChange,
    icon,
    theme,
    ref: dropdownRef,
    displayOptions: {
      search: true,
    },
    ariaLabelledBy,
    ariaLabel,
  };

  if (guide_us_only) {
    dropdownProps.displayOptions = { search: false };
    dropdownProps.icon = '';
    dropdownProps.options = { US: localizedMap.US };
  }

  return <Dropdown {...dropdownProps} />;
};

CountryDropdown.displayName = 'CountryDropdown';

export default CountryDropdown;
